// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2J4L6","footer":"ModalCreateQualiphyProcedure_footer__1ysRZ","additionData":"ModalCreateQualiphyProcedure_additionData__30xKv"};